import { render } from "./App.vue?vue&type=template&id=12ec066f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=12ec066f&lang=scss"

import exportComponent from "/Users/mfeys/Desktop/HAv2/studio-vue/18104-braun/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__